import Spinner from "common/components/Spinner"
import { useCallback, useMemo } from "react"
import "./styles.scss"

const DetailList = ({
  data,
  columns,
  onClickRow,
  activeConditionKey = "estado",
  loading,
}: $TSMigrationFixMe) => {
  const onGetLabels = useCallback(() => columns(), [columns])
  const getActiveConditionKey = (
    element: $TSMigrationFixMe,
    elementToCompare: $TSMigrationFixMe
  ) => {
    return element[activeConditionKey] === elementToCompare
  }

  const onRenderInfoBoxes = useMemo(() => {
    return onGetLabels().map((data: $TSMigrationFixMe) => {
      return (
        <li
          key={data.label}
          className='box_container box-column'
          style={{ width: data.width }}
        >
          <span>{data.label}</span>
        </li>
      )
    })
  }, [onGetLabels])

  return (
    <div className='list_detail-container'>
      <ul className='list-columns list-element'>{onRenderInfoBoxes}</ul>
      {loading ? (
        <Spinner />
      ) : (
        <ul className='items-content list-element'>
          {data?.map((element: $TSMigrationFixMe) => {
            return (
              <li
                className={`list-item ${
                  getActiveConditionKey(element, 1) ? "active" : ""
                }`}
                key={element.key}
                onClick={() =>
                  getActiveConditionKey(element, 1) && onClickRow(element)
                }
              >
                {onGetLabels().map((column: $TSMigrationFixMe) => {
                  return (
                    <div
                      className={`box_container ${column.className || ""}`}
                      key={column.key}
                      style={{ width: column.width }}
                    >
                      <span
                        onClick={() =>
                          column?.onClick && column.onClick(element)
                        }
                      >
                        {column.format
                          ? column.format(element)
                          : element[column.key]}
                      </span>
                    </div>
                  )
                })}
              </li>
            )
          })}
        </ul>
      )}
    </div>
  )
}

export default DetailList
